export const PROPERTY_SEPARATOR = '|';
export const DISCRIMINATOR_SEPARATOR = '__';
export const RESPONSE_POSTFIX = '/response';
